export const fetchingInitialMessagesRequestId = conversationId =>
  `application_conversation_fetching_initial/${conversationId}`;

export const fetchingMoreMessagesRequestId = conversationId =>
  `application_conversation_fetching_more/${conversationId}`;
